export default "__VITE_ASSET__BPAmf$WO__"